import { useCallback } from 'react'
import { useAppSelector } from 'hooks'
import { TModuleType } from 'types'

export type TModuleCheckMode = 'AND' | 'OR'

type UseCheckModuleProps = {
 modules?: TModuleType[]
 checkIsModule: (
  v?: TModuleType | TModuleType[] | null,
  mode?: TModuleCheckMode,
 ) => boolean
}

// Checks whether module(s) are enabled for the user via global settings `modules`
const useCheckModule = (): UseCheckModuleProps => {
 const modules = useAppSelector((state) => state.global.modules)

 const checkIsModule = useCallback(
  (mod?: TModuleType | TModuleType[] | null, mode: TModuleCheckMode = 'OR') => {
   // No module slug on the item → always allowed
   if (!mod) return true
   // Global settings not loaded / API doesn't send `modules` → don't hide anything
   if (!modules) return true
   if (Array.isArray(mod)) {
    if (mod.length === 0) return true
    return mode === 'OR'
     ? mod.some((v) => modules.includes(v))
     : mod.every((v) => modules.includes(v))
   }
   return modules.includes(mod)
  },
  [modules],
 )

 return { modules, checkIsModule }
}

export default useCheckModule
